export default "__VITE_ASSET__Ib7aRESZ__"